// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"1fd93c54","124":"b7e39cd4","249":"712ece63","292":"2265792b","407":"2ee50286","879":"ff2dd55d"}[chunkId] + ".chunk.css";
};